<template>
  <div class="wrapper container">
    <template v-if="isAuth">
      <header>
        <img class="logo" src="/spravka-nalog/logo.png">
        <h1 class="header">Заявка на справку для получения налогового вычета</h1>
        <p 
          class="subtitle" 
          v-html="title"
        ></p>
      </header>
      <main>
        <form 
          @submit.prevent="submit" 
          class="form"
        >
          <form-template v-bind:title="'данные налогоплательщика'">
            <template v-slot:inner>
              <div class="form-container">
                <div class="row form-row">
                  <form-input 
                    class="col-xs-12 form-input-container col-md-8"
                    v-bind:name="'fio'"
                    v-bind:readonly="true"
                    v-bind:label="'Фамилия Имя Отчество*'"
                    v-bind:type="'text'"
                    v-bind:placeholder="'Иванов Иван Иванович'"
                    v-bind:mask="'(^[А-ЯЁ]{1}[а-яё]+[ ]{1}[А-ЯЁ]{1}[а-яё]+$)|(^[А-ЯЁ]{1}[а-яё]+[ ]{1}[А-ЯЁ]{1}[а-яё]+[ ]{1}[А-ЯЁ]{1}[а-яё]+$)'"
                    v-model="formParams['fio']"
                    v-on:input="input"
                  ></form-input>
                  <form-input 
                    class="col-xs-12 form-input-container col-md-4"
                    v-bind:name="'phone'"
                    v-bind:readonly="true"
                    v-bind:label="'Телефон*'"
                    v-bind:type="'phone'"
                    v-bind:mask="'^[^.]{17}$'"
                    v-model="formParams['phone']"
                    v-on:input="input"
                  ></form-input>
                </div>
                <div class="row form-row">
                  <form-input 
                    class="col-xs-12 form-input-container col-md-4"
                    v-bind:name="'inn'"
                    v-bind:label="'ИНН*'"
                    v-bind:type="'text'"
                    v-bind:placeholder="'123456789012'"
                    v-bind:mask="'^[0-9]{12}$'"
                    v-model="formParams['inn']"
                    v-on:input="input"
                  ></form-input>
                  <form-input 
                    class="col-xs-12 form-input-container col-md-4"
                    v-bind:name="'birth'"
                    v-bind:readonly="true"
                    v-bind:label="'Дата рождения*'"
                    v-bind:type="'date'"
                    v-model="formParams['birth']"
                    v-on:input="input"
                  ></form-input>
                  <form-input 
                    class="col-xs-12 form-input-container col-md-4"
                    v-bind:name="'mail'"
                    v-bind:label="'Электронная почта*'"
                    v-bind:type="'email'"
                    v-bind:placeholder="'test@mail.ru'"
                    v-bind:mask="'^[^/]+@[^/]+.[^/]+$'"
                    v-model="formParams['mail']"
                    v-on:input="input"
                  ></form-input>
                </div>
                <div class="row form-row">
                  <form-input 
                    class="col-xs-12 form-input-container col-md-5"
                    v-bind:name="'document'"
                    v-bind:label="'Документ, удостоверяющий личность*'"
                    v-bind:type="'select'"
                    v-bind:mask="'^[^.]+$'"
                    v-bind:listvalues="documentsListPasport"
                    v-model="formParams['document']"
                    v-on:input="input"
                  ></form-input>
                  <template v-if="formParams['document'] == 'Паспорт'">
                    <form-input 
                      class="col-xs-12 form-input-container col-md-2"
                      v-bind:name="'seria'"
                      v-bind:label="'Серия*'"
                      v-bind:type="'text'"
                      v-bind:placeholder="'1234'"
                      v-bind:mask="'^[0-9]{4}$'"
                      v-model="formParams['seria']"
                      v-on:input="input"
                    ></form-input>
                    <form-input 
                      class="col-xs-12 form-input-container col-md-2"
                      v-bind:name="'number'"
                      v-bind:label="'Номер*'"
                      v-bind:type="'text'"
                      v-bind:placeholder="'123456'"
                      v-bind:mask="'^[0-9]{6}$'"
                      v-model="formParams['number']"
                      v-on:input="input"
                    ></form-input>
                    <form-input 
                      class="col-xs-12 form-input-container col-md-3"
                      v-bind:name="'date'"
                      v-bind:label="'Дата выдачи*'"
                      v-bind:type="'date'"
                      v-model="formParams['date']"
                      v-on:input="input"
                    ></form-input>
                  </template>
                </div>
                <div 
                  class="row form-row"
                >
                  <form-input 
                    class="col-xs-12 form-input-container"
                    v-bind:name="'vedomstvo'"
                    v-bind:label="'Кем выдан*'"
                    v-bind:type="'text'"
                    v-bind:placeholder="'Выдан отделом УФМС Росии по ... ну или что- то в том же духе, там в паспорте что- то такое где- то написано'"
                    v-bind:mask="'^[а-яёА-ЯЁ\-]+'"
                    v-model="formParams['vedomstvo']"
                    v-on:input="input"
                  ></form-input>
                </div>
              </div>
            </template>
          </form-template>
          <div class="form-container">
            <div class="row form-row">
              <form-input 
                class="col-xs-12 form-input-container col-md-4"
                v-bind:name="'year'"
                v-bind:label="'Налоговый период/год*'"
                v-bind:type="'select'"
                v-bind:mask="'^[^.]+$'"
                v-bind:listvalues="yearsList"
                v-model="formParams['year']"
                v-on:input="input"
              ></form-input>
              <form-input 
                class="col-xs-12 form-input-container col-md-4"
                v-bind:name="'whoclient'"
                v-bind:label="'Услуги оказаны*'"
                v-bind:labelinfo="whoLabel"
                v-bind:type="'select'"
                v-bind:mask="'^[^.]+$'"
                v-bind:listvalues="whoList.value"
                v-model="formParams['whoclient']"
                v-on:input="input"
              ></form-input>
            </div>
            <div 
              v-if="showYearWindow"
              class="message year-message"
              @click="closeYearWindow()"
            >
              <div class="message__body">
                <a 
                  @click="closeYearWindow()"
                  class="message__close"
                >
                  &#215;
                </a>
                <template v-if="formParams['year'] == 2025"> 
                  <div v-html="year2025MessageText"></div>
                </template>
                <template v-else>
                  <div v-html="yearMessageText"></div>
                </template>
              </div>
            </div>
          </div>
          <form-template v-bind:title="'данные получателя услуги'">
            <template v-slot:inner>
              <div class="form-container">
                <div class="row form-row">
                  <form-input 
                    class="col-xs-12 form-input-container col-md-8"
                    v-bind:name="'fio2'"
                    v-bind:readonly="true"
                    v-bind:placeholder="'Иванов Иван Иванович'"
                    v-bind:label="'Фамилия Имя Отчество*'"
                    v-bind:type="'text'"
                    v-bind:mask="'(^[А-ЯЁ]{1}[а-яё]+[ ]{1}[А-ЯЁ]{1}[а-яё]+$)|(^[А-ЯЁ]{1}[а-яё]+[ ]{1}[А-ЯЁ]{1}[а-яё]+[ ]{1}[А-ЯЁ]{1}[а-яё]+$)'"
                    v-model="formParams['fio2']"
                    v-bind:dinamic="dinamic"
                    v-on:input="input"
                  ></form-input>
                </div>
                <div class="row form-row">
                  <form-input 
                    class="col-xs-12 form-input-container col-md-4"
                    v-bind:name="'inn2'"
                    v-bind:label="'ИНН*'"
                    v-bind:type="'text'"
                    v-bind:placeholder="'123456789012'"
                    v-bind:mask="'^[0-9]{12}$'"
                    v-model="formParams['inn2']"
                    v-bind:dinamic="dinamic"
                    v-bind:notrequired="notNeedInn"
                    v-on:input="input"
                  ></form-input>
                  <form-input 
                    class="col-xs-12 form-input-container col-md-4"
                    v-bind:name="'birth2'"
                    v-bind:readonly="true"
                    v-bind:label="'Дата рождения*'"
                    v-bind:type="'date'"
                    v-model="formParams['birth2']"
                    v-bind:dinamic="dinamic"
                    v-on:input="input"
                  ></form-input>
                </div>
                <div class="row form-row">
                  <form-input 
                    class="col-xs-12 form-input-container col-md-5"
                    v-bind:name="'document2'"
                    v-bind:label="'Документ, удостоверяющий личность*'"
                    v-bind:type="'select'"
                    v-bind:mask="'^[^.]+$'"
                    v-bind:listvalues="documentsList"
                    v-model="formParams['document2']"
                    v-bind:dinamic="dinamic"
                    v-on:input="input"
                  ></form-input>
                  <template v-if="formParams['document2'] == 'Паспорт'">
                    <form-input 
                      class="col-xs-12 form-input-container col-md-2"
                      v-bind:name="'seria2'"
                      v-bind:label="'Серия*'"
                      v-bind:type="'text'"
                      v-bind:placeholder="'1234'"
                      v-bind:mask="'^[0-9]{4}$'"
                      v-model="formParams['seria2']"
                      v-bind:dinamic="dinamic"
                      v-on:input="input"
                    ></form-input>
                    <form-input 
                      class="col-xs-12 form-input-container col-md-2"
                      v-bind:name="'number2'"
                      v-bind:label="'Номер*'"
                      v-bind:type="'text'"
                      v-bind:placeholder="'123456'"
                      v-bind:mask="'^[0-9]{6}$'"
                      v-model="formParams['number2']"
                      v-bind:dinamic="dinamic"
                      v-on:input="input"
                    ></form-input>
                    <form-input 
                      class="col-xs-12 form-input-container col-md-3"
                      v-bind:name="'date2'"
                      v-bind:label="'Дата выдачи*'"
                      v-bind:type="'date'"
                      v-model="formParams['date2']"
                      v-bind:dinamic="dinamic"
                      v-on:input="input"
                    ></form-input>
                  </template>
                  <template v-if="formParams['document2'] == 'Свидетельство о рождении'">
                    <form-input 
                      class="col-xs-12 form-input-container col-md-2"
                      v-bind:name="'svseria'"
                      v-bind:label="'Серия*'"
                      v-bind:type="'text'"
                      v-bind:placeholder="'III-АА'"
                      v-bind:mask="'^[IVXLCDM]{1,5}[-|s][А-ЯЁ]{2}$'"
                      v-model="formParams['svseria']"
                      v-bind:dinamic="dinamic"
                      v-on:input="input"
                    ></form-input>
                    <form-input 
                      class="col-xs-12 form-input-container col-md-2"
                      v-bind:name="'svnumber'"
                      v-bind:label="'Номер*'"
                      v-bind:type="'text'"
                      v-bind:placeholder="'123456'"
                      v-bind:mask="'^[0-9]{6}$'"
                      v-model="formParams['svnumber']"
                      v-bind:dinamic="dinamic"
                      v-on:input="input"
                    ></form-input>
                    <form-input 
                      class="col-xs-12 form-input-container col-md-3"
                      v-bind:name="'svdate'"
                      v-bind:label="'Дата выдачи*'"
                      v-bind:type="'date'"
                      v-model="formParams['svdate']"
                      v-bind:dinamic="dinamic"
                      v-on:input="input"
                    ></form-input>
                  </template>
                </div>
                <div 
                  class="row form-row"
                >
                  <form-input 
                    class="col-xs-12 form-input-container"
                    v-bind:name="'vedomstvo2'"
                    v-bind:label="'Кем выдан*'"
                    v-bind:type="'text'"
                    v-bind:placeholder="'Выдан отделом УФМС Росии по ... ну или что- то в том же духе, там в паспорте или в свидетельстве что- то такое где- то написано'"
                    v-bind:mask="'^[а-яёА-ЯЁ\-]+'"
                    v-model="formParams['vedomstvo2']"
                    v-bind:dinamic="dinamic"
                    v-on:input="input"
                  ></form-input>
                </div>
              </div>
              <div class="form-container">
                <div class="row form-row">
                  <!---->
                  <form-input 
                    class="col-xs-12 form-input-container col-md-5"
                    v-bind:name="'soglasie'"
                    v-bind:label="'Даю согласие на обработку персональных данных *'"
                    v-bind:type="'checkbox'"
                    v-bind:mask="'^true$'"
                    v-model="formParams['soglasie']"
                    v-bind:dinamic="dinamic"
                    v-on:input="input"
                  ></form-input>
                  <form-input 
                    class="col-xs-12 form-input-container col-md-4"
                    v-bind:name="'method'"
                    v-bind:label="'Способ получения справки*'"
                    v-bind:type="'select'"
                    v-bind:mask="'^[^.]+$'"
                    v-bind:listvalues="methodsList"
                    v-model="formParams['method']"
                    v-bind:dinamic="dinamic"
                    v-on:input="input"
                  ></form-input>
                  <form-input 
                    v-if="formParams['method'] == 'На электронную почту'"
                    class="col-xs-12 form-input-container col-md-3"
                    v-bind:name="'mailmethod'"
                    v-bind:label="'Адрес почты*'"
                    v-bind:type="'text'"
                    v-bind:mask="'^[^/]+@[^/]+.[^/]+$'"
                    v-bind:listvalues="methodList"
                    v-model="formParams['mailmethod']"
                    v-bind:dinamic="dinamic"
                    v-on:input="input"
                  ></form-input>
                </div>
              </div>
            </template>
          </form-template>
          <input 
            type="submit" 
            class="submit" 
            v-bind:class="{disabled: formErorrs || windowIsLoaded}"
            :disabled="formErorrs || windowIsLoaded"  
            :value="windowIsLoaded ? 'Подождите...' : 'отправить заявку'"
          >
        </form>
        <div class="form-subtitle">
          <span class="red">Примечание.</span>   Заполняя поля формы заявки и нажимая кнопку “Отправить заявку” , Вы подтверждаете, что все персональные данные лиц, указанные в данной форме заявки, Вы предоставляете с их добровольного согласия.
          <br/><br/>* - обязательно к заполнению
        </div> 

        <div 
          class="message"
          v-if="showSMSWindow"
        >
          <div class="message__body">
            <form 
              class="form-sms"
              @submit.prevent="sendCodeFromSMS"  
            >
              <div
                v-if="message"
                class="form-sms__message"
                v-bind:class="{error: !messageSuccess}"
                v-html="message"
              ></div>
              <template v-if="!hideCodeForm">
                <input
                  class="form-sms__input"
                  v-model="code" 
                  type="text"
                  v-bind:readonly="window2IsLoaded"
                  placeholder="99999"
                >
                <input 
                  class="form-sms__submit"
                  v-bind:class="{disabled: incorrectCode || window2IsLoaded}"
                  type="submit" 
                  :disabled="incorrectCode || window2IsLoaded"  
                  :value="window2IsLoaded ? 'Ждите...' : 'Отправить'"
                >
              </template>
            </form>
          </div>
        </div>
      </main>
      </template>
      <template v-else>
        <form
          v-if="codeIsSended"
          @submit.prevent="sendAuthCode" 
          class="form form--mini"
        >
          <form-template v-bind:title="'Авторизация'">
            <template v-slot:inner>
              <div class="form-container">
                <p>{{ messageAuth }}</p>
                
                <div class="row form-row">
                  <form-input 
                    class="col-xs-12 form-input-container"
                    v-bind:name="'codeAuth'"
                    v-bind:label="'Код подтверждения*'"
                    v-bind:type="'number'"
                    v-bind:mask="'^[^.]{5}$'"
                    v-model="codeAuth"
                  ></form-input>
                </div>
                <div
                  v-if="messageAuthCode"
                  class="form-sms__message"
                  v-bind:class="{error: messageAuthCodeError}"
                  v-html="messageAuthCode"
                ></div>
              </div>
            </template>
          </form-template> 
          <input 
            type="submit" 
            class="submit" 
            value="Отправить"
            v-bind:class="{disabled: codeAuthIsNotCorrect}"
            :disabled="codeAuthIsNotCorrect"
          >
        </form>
        <form
          v-else
          @submit.prevent="auth" 
          class="form form--mini"
        >
          <form-template v-bind:title="'Авторизация'">
            <template v-slot:inner>
              <div class="form-container">
                <h3>Здравствуйте!</h3>
                <p>Для продолжения формирования заявки на справку для получения налогового вычета авторизуйтесь!</p>
                
                <div class="row form-row">
                  <form-input 
                    class="col-xs-12 form-input-container"
                    v-bind:name="'phone'"
                    v-bind:label="'Телефон*'"
                    v-bind:type="'phone'"
                    v-bind:mask="'^[^.]{17}$'"
                    v-model="formParamsAuth['phone']"
                  ></form-input>
                  <form-input 
                    class="col-xs-12 form-input-container"
                    v-bind:name="'date'"
                    v-bind:label="'Дата рождения*'"
                    v-bind:type="'date'"
                    v-model="formParamsAuth['date']"
                  ></form-input>
                </div>
                <div
                  v-if="messageAuth"
                  class="form-sms__message"
                  v-bind:class="{error: messageAuthError}"
                  v-html="messageAuth"
                ></div>
              </div>
            </template>
          </form-template> 
          <input 
            type="submit" 
            class="submit" 
            :value="formIsFreeze ? 'подождите...' : 'авторизоваться'"
            v-bind:class="{disabled: formErorrsAuth || formIsFreeze}"
            :disabled="formErorrsAuth || formIsFreeze"
          >
        </form>
      </template>
    <footer>

    </footer>
  </div>
</template>

<script setup>
import { ref, reactive, watch, computed, onMounted } from 'vue';
import formTemplate from './components/formTemplate';
import formInput from './components/formInput';
import CheckForm from './checkForm';

const formIsFreeze = ref(false);
const window2IsLoaded = ref(false);
const windowIsLoaded = ref(false);
const hideCodeForm = ref(false);
const whoListDefault = reactive([]);
const whoList = reactive([]);
const data2025Start = ref('_');
const data2025End = ref('_');
//const client = ref('48750ac8614872cacca78682aab39fab375f6fdfbb2df1ceec69185fc8559f9c41052e2f');
const client = ref();
const codeAuthIsNotCorrect = computed(() => {
  return !codeAuth.value || String(codeAuth.value).length !== 5;
});
const messageAuthCode = ref(null);
const messageAuthCodeError = ref(false);
const codeAuth = ref(null);
const codeIsSended = ref(false);
const messageAuth = ref(null);
const messageAuthError = ref(false);
const dinamic = ref(1);
const isAuth = ref(false);
const formErorrsAuth = computed(() => {

 return !formParamsAuth['phone'] || !formParamsAuth['date'];
});
const messageSuccess = ref(true);
const message = ref('На номер телефона отправлен SMS код, введите его в поле ниже:');
const codeTrue = ref(null);
const title = ref(null);
const code = ref(null);
const club = ref(null);
const showSMSWindow = ref(false);
const formParamsAuth = reactive({});
const formParams = reactive({
  document: 'Паспорт'
});
const validatedFormParams = reactive({
  document: 'Паспорт'
});
const incorrectCode = computed(() => {
  //alert(code.value);
  return !(code.value && code.value.length == 5);
});
onMounted(() => {

  /**
   * Достаем клуб из URL,
   * если он есть
   */
  const url = new URL(window.location.href);
  club.value = url.searchParams.get('club');

  /*
  fetch('title.php?club='+club.value)
    .then(response => response.text())
    .then(text => {
      title.value = text;
    });
  */
});

const year2025MessageText = computed(() => {
  return 'Справка по Вашему обращению будет сформирована только после оказания услуги (т.е. после окончания договора/текущей клубной карты). Документ будет подготовлен и отправлен Вам в период с '+data2025Start.value+' по '+data2025End.value+'.<br><br><a target="_blank" href="https://golds-fitness.com/shownews/25_yanvarya_2022_nalogovyy__vychet__za__zanyatia_sportom/">Подробнее</a>';
});
/**
 * Здесь мы пытаемся понять- необходим инн или нет?
 * Критерий следующий- если тот, на кого оформляется справка не совершеннолетний,
 * то инн не нужен!
 */
  const notNeedInn = computed(() => {
  const dt = new Date();
  const thisYear = dt.getFullYear();
  const dt18Age = dt.setFullYear(thisYear - 18);

  if('birth2' in validatedFormParams === false) return true;
  const dateFromField = new Date(validatedFormParams['birth2'])
  //console.log(dateFromField > dt18Age);
  return dateFromField > dt18Age;
});

const checkForm = new CheckForm(validatedFormParams, notNeedInn);
const formErorrs = computed(() => {
  //console.log('recalculate formErrors...');
  //console.log(checkForm.check());
 // console.log(checkForm.check().count);
  return checkForm.check().count;
});

const showYearWindow = ref(false);
const yearMessageText = ref('Справка по форме КНД 1151160 об оплате физкультурно-оздоровительных услуг для получения налогового вычета может быть предоставлена только за 2024 год. За период 2022 и 2023 год, для получения налогового вычета к налоговой декларации необходимо приложить копию договора и чеки об оплате');
const whoLabel = ref('Возврат за  физкультурно-оздоровительные услуги возможен только за себя и за ребенка до 18 лет (если ребёнок обучается на очном отделении, то до 24 лет, в этом случае необходимо дополнительно указать ИНН ребенка). Если в списке отсутствует нужный получатель услуги, пожалуйста обратитесь в Отдел продаж клуба');
const yearsList = reactive([
  '2022',
  '2023',
  '2024',
  '2025'
]);
const documentsListPasport = reactive([
  'Паспорт'
]);
const documentsList = reactive([
  'Паспорт',
  'Свидетельство о рождении'
]);
const clientsList = reactive([
  'Мне',
  'Ребенку'
]);

const methodsList = reactive([
  'Лично на бумажном носителе',
  'На электронную почту',
  'Направить напрямую в налоговый орган'
]);


watch(() => formParams['year'], (newValue) => {
  if(newValue == 2022 || newValue == 2023 || newValue == 2025) openYearWindow();
});
watch(() => formParams['client'], (value) => {
  if(value == 'Мне') {
    if(formParams['document']) formParams['document2'] = formParams['document'];
    if(formParams['birth']) formParams['birth2'] = formParams['birth'];
    if(formParams['inn']) formParams['inn2'] = formParams['inn'];
    if(formParams['fio']) formParams['fio2'] = formParams['fio'];
    if(formParams['seria']) formParams['seria2'] = formParams['seria'];
    if(formParams['number']) formParams['number2'] = formParams['number'];
    if(formParams['date']) formParams['date2'] = formParams['date'];
    if(formParams['vedomstvo']) formParams['vedomstvo2'] = formParams['vedomstvo'];
    dinamic.value ++;
  }
});
watch(client, val => {
  console.log(val);
  setClientInfo(val, true);
  checkWhoList();
});
function getMethodCode(title) {
  return methodsList.indexOf(title);
}
function setClientInfo(searchedClient, primary = false) {
  const formData = new FormData();
  formData.append('client', client.value);
  formData.append('child', searchedClient);

  fetch('clientInfo.php', {
    method: 'POST',
    body: formData
  }).then(response => response.json())
  .then(json => {

    if(json.success && primary) setFormParamsForChildrenPrimary(json.result);

    if(json.success && !primary) setFormParamsForChildrenSecondary(json.result);

    if(json.success && 'd_contract_date_start' in json.result) {
      data2025Start.value = json.result.d_contract_date_start;
      data2025End.value = json.result.d_contract_date_end;
    }
  });
}
function getDateForInput(dmy) {
  const arr = dmy.split('.');
  return arr[2]+'-'+arr[1]+'-'+arr[0];
}
function setFormParamsForChildrenSecondary(obj) {
  formParams['fio2'] = obj.s_name;
  formParams['birth2'] = getDateForInput(obj.s_birthday);
  formParams['inn2'] = obj.s_inn;

  formParams['seria2'] = obj.s_doc1_1;
  formParams['number2'] = obj.s_doc1_2;
  formParams['date2'] = getDateForInput(obj.s_doc1_3);
  formParams['vedomstvo2'] = obj.s_doc1_4;

  formParams['svseria'] = obj.s_doc2_1;
  formParams['svnumber'] = obj.s_doc2_2;
  formParams['svdate'] = getDateForInput(obj.s_doc2_3);
  formParams['vedomstvo2'] = obj.s_doc2_4;

  documentsList.value = obj.s_doc_list.split(',');
  formParams['document2'] = obj.s_doc2_type;

  formParams['mailmethod'] = obj.s_email;
}
function setFormParamsForChildrenPrimary(obj) {
  formParams['fio'] = obj.s_name;
  formParams['birth'] = obj.s_birthday;
  formParams['mail'] = obj.s_email;
  formParams['phone'] = obj.s_phone;
  formParams['birth'] = getDateForInput(obj.s_birthday);
  formParams['inn'] = obj.s_inn;

  formParams['seria'] = obj.s_doc1_1;
  formParams['number'] = obj.s_doc1_2;
  formParams['date'] = getDateForInput(obj.s_doc1_3);
  formParams['vedomstvo'] = obj.s_doc1_4;

  formParams['svseria'] = obj.s_doc2_1;
  formParams['svnumber'] = obj.s_doc2_2;
  formParams['svdate'] = getDateForInput(obj.s_doc2_3);
  formParams['vedomstvo'] = obj.s_doc2_4;

  formParams['mailmethod'] = obj.s_email;
}
function getWhoclient() {
  if('whoclient' in formParams && formParams['whoclient']) {
    return whoListDefault.value.filter(element => {
      return formParams['whoclient'] == element.s_name;
    })[0].s_client;
  }
  return null;
}
function checkWhoList() {
  if(!whoList.length) {
    const formData = new FormData;
    formData.append('client', client.value);

    fetch('wholist.php', {
      method: 'POST',
      body: formData
    }).then(response => response.json())
    .then(json => {
      //console.log(json);

      if(json.success) {
        whoListDefault.value = json.result;
        whoList.value = [];
        whoList.value = json.result.map(el => {
          return el.s_name;
        });
        //console.log(whoList);
      }
    });
  }
}
function sendAuthCode() {
  const formO = new FormData();
  formO.append('code', codeAuth.value);
  formO.append('phone', formParamsAuth['phone'].replace('+7', ''));
  formO.append('date', formParamsAuth['date']);

  fetch('code.php', {
    method: 'POST',
    body: formO
  }).then(response => response.json())
  .then(json => {
    //console.log(json);

    if(json.success == 1) {
      messageAuthCodeError.value = false;
      client.value = json.result.s_client;
      isAuth.value = true;
    } else {
      messageAuthCodeError.value = true;
      messageAuthCode.value = json.result.s_result;
    }
    messageAuthCode.value = null;
  });
}
function auth() {
  const formO = new FormData();
  formIsFreeze.value = true;
  formO.append('phone', formParamsAuth['phone'].replace('+7', ''));
  formO.append('date', formParamsAuth['date']);

  fetch('auth.php', {
    method: 'POST',
    body: formO
  }).finally(() => {
    formIsFreeze.value = false;
  })
  .then(response => response.json())
  .then(json => {
    //console.log(json);

    if(json.success == 1) {
      messageAuthError.value = false;
      codeIsSended.value = true;
    } else {
      messageAuthError.value = true;
    }
    messageAuth.value = json.result;
  });
  //isAuth.value = true;
}
function submit() {
  sendForm();
  
}
function openSMSWindow() {
  showSMSWindow.value = true;
}
function closeSMSWindow() {
  showSMSWindow.value = false;
}
function sendCodeFromSMS() {
  window2IsLoaded.value = true;
  const formO = new FormData();
  formO.append('phone', validatedFormParams['phone'].replace('+7', ''));
  formO.append('code', code.value);

  fetch('finish.php', {
    method: 'POST',
    body: formO
  }).finally(() => {
    window2IsLoaded.value = false;
  })
  .then(response => response.json())
  .then(json => {
    console.log(json);
    message.value = json.result;
    messageSuccess.value = json.success;
    if(json.success) hideCodeForm.value = true;
    code.value = null;
  })
}
function sendForm() {
  windowIsLoaded.value = true;

  if(!checkForm.check().count) {
    const formObj = new FormData();
    const arrOtl = [];

    for(let key in validatedFormParams) {
      arrOtl.push(key+' => '+validatedFormParams[key]);
      if(key == 'whoclient') {
        formObj.append(key, getWhoclient(validatedFormParams[key]));
      } else if(key == 'method') {
        formObj.append(key, getMethodCode(validatedFormParams[key]));
      } else {
        formObj.append(key, validatedFormParams[key]);
      } 
    }
    if(client.value) formObj.append('client', client.value);

    //console.log(arrOtl);

    fetch('ajax.php', {
      method: 'POST',
      body: formObj
    }).finally(() => {
      windowIsLoaded.value = false;
    })
      .then(response => response.json())
      .then(json => {
      //console.log(json);
      if(json.success) {
        openSMSWindow();
        codeTrue.value = json.s_answer;
      } else {

      }
    });
  }
}
function openYearWindow() {
  showYearWindow.value = true;
}
function closeYearWindow() {
  showYearWindow.value = false;
  
  if(formParams['year'] == '2022' || formParams['year'] == '2023') {
    formParams['year'] = '2024';
  };
}
function input(name, value) {
  validatedFormParams[name] = value;
  //if(name == 'client') checkWhoList();
  if(name == 'whoclient') setClientInfo(getWhoclient());
}
</script>

<style lang="scss">
@use '../node_modules/bootstrap-grid/dist/grid.min.css';

body{
  font-size: 16px;
  font-family: 'Verdana';
}
.form{
  margin-top: 3em;
}
.logo{
  display: block;
  width: 250px;
  margin: 65px auto;
}
.header{
  display: block;
  text-align: center;
  padding: 0 15px;
  font-size: 1em;
  margin-bottom: 2em;
  text-transform: uppercase;
  font-weight: bold;
}
.subtitle{
  display: block;
  text-align: center;
}
.form-container{
  width: 80%;
  padding: 15px;
  margin: 0 auto;
}
.row>*{
  box-sizing:border-box;
}
.form-subtitle{
  font-variant: italic;
  font-size: 1em;
  margin-top: 3em;

  .red{
    color: #E20101;
    font-weight: bold;
  }
}
.form-input-container{
  margin: 1.5em 0;
}
.submit{
  display: block;
  margin: 3em auto;
  line-height: 1.2em;
  width: 250px;
  max-width: 100%;
  box-sizing: border-box;
  text-align: center;
  border: none;
  padding: 10px 20px;
  border-radius: calc((1.5em + 10px) / 2);
  font-size: 1.2em;
  text-transform: uppercase;
  color: #fff;
  outline: none;
  background-color: #E20101;
  cursor: pointer;

  &.disabled{
    filter: grayscale(1);
    cursor: default;
  }
}
/**
message
*/
.message{
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.5);
  z-index:999;

  &__body{
    position: absolute;
    top: 0;
    left:0;
    right:0;
    bottom:0;
    margin: auto;
    z-index: 1000;
    width: 300px;
    height: 200px;
    display: flex;
    justify-content: left;
    align-items: center;
    padding: 15px 30px;
    background-color: #fff;
    border-radius: 4px;
  }
  &__close{
    cursor: pointer;
    position: absolute;
    right: 5px;
    top: 5px;
    text-align: center;
    line-height: 1em;
    color: #999;
  }
}

.form{
  &--mini{
    max-width: 400px;
    margin: 50px auto;
    display: block;
  }
}
.form-sms{


  &__input{
    padding: 8px 15px;
    border-radius: 8px 0 0 8px;
    border: 1px solid #666;
    outline: none;
  }
  &__submit{
    padding: 8px 15px;
    border-radius: 0 8px 8px 0;
    border: 1px solid transparent;
    background-color: #E20101;
    color: #fff;
    cursor: pointer;

    &.disabled{
      filter: grayscale(1);
      cursor: default;
    }
  }
  &__message{
    margin-bottom: 15px;
    padding: 1em;
    border: 1px solid #393;
    border-radius: 4px;
    background-color: #9f9;

    &.error{
      background-color: #f99;
      border-color: #933;
    }
  }
}
</style>
